import React from 'react';
import { verificationCode } from '@Services/api';
import { message } from 'antd';
import debounce from 'lodash/debounce';
import styles from './VerificationCodeItem.module.less';

export interface IProps {
  onCallBack?: (res?: any) => void;
  style: React.CSSProperties;
  type: string;
  account: string;
}

export interface IState {
  interval: number;
  anew: number;
}

class VerificationCodeItem extends React.PureComponent<IProps, IState> {
  readonly state = {
    interval: 0,
    anew: 0,
  };
  private settimeout: any;
  private isClose = true;
  componentWillUnmount() {
    window.clearInterval(this.settimeout);
  }
  async requireCode() {
    if (!this.isClose) {
      return;
    }
    this.isClose = false;

    const { account, type, onCallBack } = this.props;

    let params = {
      account: account,
      type: type,
      agree: 1,
    };

    const res = await verificationCode(params);

    if (res.status === '12000') {
      message.success(res.data.content || '驗證碼傳送成功！');
      this.setState({
        interval: 60,
      });
      onCallBack && onCallBack(res);
      this.settimeout = window.setInterval(() => this.countDown(), 1000);
    } else if (res.status === '13000') {
      message.error(res.message);
    }
    this.isClose = true;
  }
  countDown() {
    const { interval } = this.state;
    let set_second;

    if (interval > 0) {
      set_second = interval - 1;
    } else {
      set_second = interval;
      window.clearInterval(this.settimeout);
    }

    this.setState({
      interval: set_second,
      anew: 1,
    });
  }
  render() {
    const { interval, anew } = this.state;
    const { style, account } = this.props;

    // const { content = "重新發送", account = "" } = this.props;

    return (
      <section className={styles['VerificationCodeItem']} style={style}>
        <button
          className={styles['code-request']}
          onClick={debounce(() => this.requireCode(), 200)}
          disabled={account.length !== 10 || interval > 0}
          style={interval > 0 ? { color: '#333' } : {}}
        >
          {interval > 0 ? `${interval}S` : anew === 0 ? '發送驗證碼' : '重新發送'}
        </button>
      </section>
    );
  }
}

export default VerificationCodeItem;
